import { Erinnerung } from '../types';

const tageBis = (datum: string): number => {
  const heute = new Date();
  heute.setHours(0, 0, 0, 0);
  const ziel = new Date(datum + 'T00:00:00');
  return Math.round((ziel.getTime() - heute.getTime()) / (1000 * 60 * 60 * 24));
};

/** Farbe und Beschriftung nach Fälligkeit: überfällig rot, innerhalb von 30 Tagen gelb. */
export const faelligkeit = (faelligAm: string) => {
  const tage = tageBis(faelligAm);
  if (tage < 0) return { card: 'border-l-4 border-red-400 bg-red-50', badge: 'bg-red-100 text-red-700', label: `${Math.abs(tage)} Tage überfällig` };
  if (tage <= 30) return { card: 'border-l-4 border-amber-400 bg-amber-50', badge: 'bg-amber-100 text-amber-700', label: tage === 0 ? 'Heute fällig' : `In ${tage} Tagen` };
  return { card: 'border-l-4 border-gray-200 bg-white', badge: 'bg-gray-100 text-gray-600', label: `In ${tage} Tagen` };
};

/** Von Hand angelegte Erinnerungen tragen eine Notiz, die aus Berichten den Artikel. */
export const erinnerungText = (e: Erinnerung) => e.notiz || e.artikelBezeichnung || '';
